import React, { FC, useCallback, useMemo } from 'react';
import { useSelector, useStore } from 'react-redux';
import { ViewportMenu } from 'ui';
import { setPose } from '../actions/homePose';
import { HomeState } from '../store/homeState';
import { homeStateExt } from '../store/homeStateExt';
import * as S from './homePoses.styles';

/**
 * HomePoses custom hook.
 */
const usePoses = () => {
  const { dispatch, getState } = useStore<HomeState>();

  const poseId = useSelector((state: HomeState) => state.poseId);
  const styleId = useSelector((state: HomeState) => state.style);

  const poses = useMemo(() => (styleId ? homeStateExt.stylePoses! : []), [styleId]);

  return { dispatch, getState, poseId, poses };
};

/**
 * Poses viewport menu.
 */
export const HomePoses: FC = () => {
  const { dispatch, getState, poseId, poses } = usePoses();

  const items = useMemo(
    () =>
      poses.map(p => {
        return {
          icon: () => <S.ItemImage $mask={p.preview} />,
          key: p.id,
        };
      }),
    [poses],
  );

  const onChange = useCallback(
    (key: string) => {
      setPose(dispatch, getState, key);
    },
    [dispatch, getState],
  );

  return <ViewportMenu items={items} onChange={onChange} selection={poseId || undefined} />;
};
